import { useAsync } from '@atlassiansox/bxp-content-framework';
import { useCallback } from 'react';
import { useTrelloClient } from '../contexts/trello-client-context';
// Use stub client in local development
// import { stubTrelloClient as useTrelloClient } from '../../client/stubs';
export function useMember(id = 'me') {
    const client = useTrelloClient();
    return useAsync(useCallback(() => client.getMember({
        id,
        fields: ['organizations'],
        organizations: 'all',
        organizationFields: [
            'name',
            'displayName',
            'memberships',
            'url',
            'products'
        ],
        credits: 'freeTrial'
    }), [id]));
}
//# sourceMappingURL=use-member.js.map